import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import styles from './PrivateAccessModalHeader.module.less';
function PrivateAccessModalHeader(props) {
    const { targetCount, targetType } = props;
    return (_jsxs("div", { className: styles.privateAccessModalHeader, children: ["Share Private Access", targetCount > 1 && _jsx("div", { className: styles.subHeader, children: `${targetCount} ${targetType}s will be affected` })] }));
}
export default observer(PrivateAccessModalHeader);
